import { cache } from "react"
import { listProducts } from "@/lib/data/products"

/** Dedupes generateMetadata + page + ProductDetailsPage in one request. */
export const getProductByHandle = cache(
  async (handle: string, locale: string) => {
    const { response } = await listProducts({
      countryCode: locale,
      queryParams: { handle, limit: 1 },
    })
    return response.products[0] ?? null
  }
)
